// extracted by mini-css-extract-plugin
export var externalLink = "_cv-0";
export var internalLinkLabel = "_cv-1";